import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {paramsHelper} from "../../helpers/params-helper";
import {ActivatedRoute} from "@angular/router";
import {BusService} from "../../services/bus.service";
import {IDynamicRouteData} from "../../routing/dynamic-routing.module";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {ILog} from "../../components/nv-logs/nv-logs.component";
import {Subject} from "rxjs/Subject";
declare var $:any;

@Component({
  selector: 'app-logs-page',
  templateUrl: './logs-page.component.html',
  styles: []
})
export class LogsPageComponent implements OnInit, OnDestroy {

  _jsonBody:ElementRef;
  @ViewChild("jsonBody") set jsonBody(val:ElementRef)
  {
   this._jsonBody = val;
   this.showJson(this.log);
  }

  log:ILog;

  pageParams = paramsHelper.page()
    .setDisabledOptionVisible(false)
    .setTitle("Просмотр логов");

  collectionParams = paramsHelper.collection()
    .setListLabels("ID пользователя", "%userId%")
    .setSearchParams(paramsHelper.search()
      .addParam("userId", SEARCH_PROP_TYPES.STRING_STRICT, null)
      .addParam("tag", SEARCH_PROP_TYPES.STRING_MULTI, null)
      .addParam("message", SEARCH_PROP_TYPES.STRING_MULTI, null)
      .addParam("time", SEARCH_PROP_TYPES.NUMBER_LTE, null)
      .addParam("time", SEARCH_PROP_TYPES.NUMBER_GTE, null)
      .addParam("data.os", SEARCH_PROP_TYPES.NUMBER, null));

  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private busService: BusService,
              private activatedRoute: ActivatedRoute)
  {

  }

  ngOnInit()
  {
    const data = this.activatedRoute.snapshot.data as IDynamicRouteData;
    this.collectionParams.setTarget(data.target);
    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(e =>
      {
        this.log = e.document as ILog;
        this.showJson(this.log);
      })
  }

  ngOnDestroy()
  {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  showJson(log:ILog)
  {
    console.log(`show json`);
    if (this._jsonBody != null)
    {
      const logJson:any = JSON.parse(JSON.stringify(log));
      $(this._jsonBody.nativeElement).JSONView(logJson, { collapsed: false });
    }
  }


}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/logs/logs-page.component.ts